<div class="modal-header">
    <button class="close" type="button" mat-dialog-close aria-label="Close" ><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title">Notes</h4>
</div>
<div class="modal-body">
    <note [noteIdentificationValue]="detailsId" [noteIdentificationTypeId]="1"
        [countDisplayClass]="'note-count'" [isWip]="false" [isReadonly]="false">
    </note>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" mat-dialog-close aria-label="Close">Close</button>
    </div>
</div>
